import { render, staticRenderFns } from "./AddressDialog.vue?vue&type=template&id=81269a04&scoped=true"
import script from "./AddressDialog.vue?vue&type=script&lang=js"
export * from "./AddressDialog.vue?vue&type=script&lang=js"
import style0 from "./AddressDialog.vue?vue&type=style&index=0&id=81269a04&prod&lang=scss"
import style1 from "./AddressDialog.vue?vue&type=style&index=1&id=81269a04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81269a04",
  null
  
)

export default component.exports